import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

export interface ILayoutGridItem {
  $width?: number;
  $widthSm?: number;
  $widthMd?: number;
  $widthLg?: number;
  $orderLtMd?: number;
  $orderMd?: number;
}

export const LayoutGridItem = styled.div.withConfig({ componentId: 'sc-1cmpki5-0' })<ILayoutGridItem>`
    flex: 1 0 auto;
    width: 100%;
    max-width: 100%;

    ${({ $width }) =>
      $width &&
      css`
            width: ${$width}%;
            max-width: ${$width}%;
        `}

    ${({ $widthSm }) =>
      $widthSm &&
      css`
            ${(props) => props.theme.breakpoint.Sm} {
                width: ${$widthSm}%;
                max-width: ${$widthSm}%;
            }
        `}

  ${({ $widthMd }) =>
    $widthMd &&
    css`
            ${(props) => props.theme.breakpoint.Md} {
                width: ${$widthMd}%;
                max-width: ${$widthMd}%;
            }
        `}

  ${({ $widthLg }) =>
    $widthLg &&
    css`
            ${(props) => props.theme.breakpoint.Lg} {
                width: ${$widthLg}%;
                max-width: ${$widthLg}%;
            }
        `}

    ${({ $orderLtMd }) =>
      $orderLtMd &&
      css`
            ${(props) => props.theme.breakpoint.LtMd} {
                order: ${$orderLtMd};
            }
        `}

    ${({ $orderMd }) =>
      $orderMd &&
      css`
            ${(props) => props.theme.breakpoint.Md} {
                order: ${$orderMd};
            }
        `}
`;

export interface ILayoutGrid {
  $spacing?: number;
  $align?: 'start' | 'end' | 'center';
}

export const LayoutGrid = styled.div.withConfig({ componentId: 'sc-1cmpki5-1' })<ILayoutGrid>`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    list-style: none;
    padding: 0;
    margin: 0;

    ${({ $spacing }) =>
      $spacing &&
      css`
            margin: -${size($spacing / 2)};

            ${LayoutGridItem} {
                padding: ${size($spacing / 2)};
            }
        `}

    ${({ $align }) =>
      $align === 'end'
        ? css`
                  align-items: flex-end;
              `
        : $align === 'center'
          ? css`
                  align-items: center;
              `
          : css`
                  align-items: flex-start;
              `}
`;
